goog.module('yext.developerapps.tableauconnector.DataRequestor');
goog.module.declareLegacyNamespace();

const ConfigureSchema = goog.require('yext.developerapps.tableauconnector.ConfigureSchema');

/* Helper class used to make data requests and process ajax responses */
class DataRequestor {
  constructor(ajaxActions, schema, connectionData) {
    this.ajaxActions = ajaxActions;
    this.schema = schema;
    this.connectionData = connectionData;

    this.processRow = this.processRow.bind(this);
    this.setConnectionData = this.setConnectionData.bind(this);
    this.getData = this.getData.bind(this);
    this.getEntityData = this.getEntityData.bind(this);
    this.makeRequestAndProcessRows = this.makeRequestAndProcessRows.bind(this);
  }

  setConnectionData(connectionData) {
    this.connectionData = connectionData;
  }

  getEntityData() {
    var data = this.makeRequestAndProcessRows(
      'getEntityData',
      this.ajaxActions.getEntityData.bind(this),
      this.schema.getTableFields('entities'),
    );
    return data;
  }

  getAnalyticsData(tableMetadata) {
    return this.makeRequestAndProcessRows(
      'getAnalyticsData',
      tableMetadata['method'].bind(
        this,
        this.connectionData,
        tableMetadata['route'],
        tableMetadata['metrics'],
        tableMetadata['yextDimensions'],
        tableMetadata['tableauDimensions']),
      this.schema.getTableFields(tableMetadata['table']));
  }

  getReviewsData() {
    var data = this.makeRequestAndProcessRows(
      'getReviewsData',
      this.ajaxActions.getReviewsData.bind(this, this.connectionData),
      this.schema.getTableFields('reviews'),
    );
    return data;
  }

  makeRequestAndProcessRows(description, ajaxFn, dataFields) {
    console.log('Making request for ' + description);
    var data = ajaxFn();
    var rows = data.map(row => this.processRow(row, dataFields));
    console.log('Returned # rows: ' + rows.length);
    return rows;
  }

  processRow(inputRow, dataFields) {
    var tableRow = {};
    for (var field in dataFields) {
      var tableColId = dataFields[field]['id'];
      var inputField = dataFields[field]['yextId'];
      var fieldType = dataFields[field]['dataType'];
      var inputValue;
      if (fieldType == 'date') {
        inputValue = this.parseDateValue(inputRow[inputField]);
      } else {
        inputValue = inputRow[inputField];
      }
      tableRow[tableColId] = inputValue;
    }
    return tableRow;
  }

  parseDateValue(value) {
    if (typeof value == 'number') {
      var date = new Date(value);
      return date;
    }
    return value;
  }

  getData(tableId) {
    var Table = ConfigureSchema.Table;
    if (tableId == Table.ENTITIES) {
      return this.getEntityData();
    }
    if (tableId == Table.REVIEWS) {
      return this.getReviewsData();
    }
    var tableMetadata = this.getAnalyticsTablesMetadata();
    return this.getAnalyticsData(tableMetadata.get(tableId));
  }

  // yextDimensions represents the request id of the dimension
  // tableauDimensions represents the response id of the dimension
  // new dimensions may have the same request and response ids, so yextDimensions and tableauDimensions
  // may be identical
  getAnalyticsTablesMetadata() {
    var metadata = new Map();
    metadata.set(
      ConfigureSchema.Table.METRICS, {'table': ConfigureSchema.Table.METRICS,
        'method': this.ajaxActions.getBatchedAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getMetricsData(),
        'metrics': [
          ['PROFILE_VIEWS', 'SEARCHES', 'FEATURED_MESSAGE_CLICKS'],
          ['YELP_PAGE_VIEWS'],
          ['FACEBOOK_LIKES', 'FACEBOOK_TALKING_ABOUT', 'FACEBOOK_CHECKINS', 'FACEBOOK_PAGE_VIEWS', 'FACEBOOK_CTA_CLICKS'],
          ['FACEBOOK_EVENT_NEW_RSVPS', 'FACEBOOK_IMPRESSIONS', 'FACEBOOK_POST_IMPRESSIONS', 'FACEBOOK_TALKING_ABOUT', 'FACEBOOK_WERE_HERE'],
          ['FOURSQUARE_DAILY_CHECKINS'],
          ['INSTAGRAM_POSTS'],
          ['GOOGLE_SEARCH_VIEWS', 'GOOGLE_MAP_VIEWS'],
          ['GOOGLE_SEARCH_QUERIES'],
          ['GOOGLE_CUSTOMER_ACTIONS'],
          ['GOOGLE_USER_PHOTOS', 'GSC_CLICKS', 'GSC_CTR', 'GSC_IMPRESSIONS', 'GSC_POSITION'],
          ['AVERAGE_RATING', 'NEW_REVIEWS'],
          ['STOREPAGES_SESSIONS', 'STOREPAGES_PAGEVIEWS', 'STOREPAGES_DRIVINGDIRECTIONS',
            'STOREPAGES_PHONECALLS', 'STOREPAGES_CALLTOACTIONCLICKS', 'STOREPAGES_CLICKSTOWEBSITE'],
          ['CLICKS', 'CONVERSIONS', 'CONVERSION_RATE', 'CONVERSION_VALUE', 'VALUE_PER_CONVERSION'],
          ['IST_AD_MATCHES', 'IST_AD_PRESENCE', 'IST_AVERAGE_FIRST_LOCAL_PACK_MATCH_POSITION',
            'IST_AVERAGE_FIRST_MATCH_POSITION', 'IST_AVERAGE_FIRST_ORGANIC_MATCH_POSITION'],
          ['IST_AVERAGE_LOCAL_PACK_NUMBER_OF_RESULTS', 'IST_AVERAGE_LOCAL_PACK_POSITION',
            'IST_KNOWLEDGE_CARD_EXISTED', 'IST_LOCAL_PACK_EXISTED', 'IST_LOCAL_PACK_PRESENCE'],
          ['IST_LOCAL_PACK_SHARE_OF_SEARCH', 'IST_MATCHES_PER_SEARCH', 'IST_ORGANIC_SHARE_OF_SEARCH',
            'IST_SEARCH_REQUESTS', 'IST_SHARE_OF_INTELLIGENT_SEARCH', 'IST_TOTAL_MATCHES'],
          ['KEYWORD_MENTIONS', 'KEYWORD_SENTIMENT'],
          ['LISTINGS_LIVE', 'POWERLISTINGS_LIVE'],
          ['PROFILE_UPDATES', 'TICKET_CLICKS', 'SOCIAL_ACTIVITIES', 'PUBLISHER_SUGGESTIONS'],
          ['DUPLICATES_DETECTED', 'DUPLICATES_SUPPRESSED'],
          ['EVENT_PROFILEVIEWS', 'EVENT_SEARCHES'],
          ['YELP_CUSTOMER_ACTIONS']],
        'yextDimensions': ['ENTITY_IDS', 'DAYS'],
        'tableauDimensions': ['entity_id', 'day']});
    metadata.set(
      ConfigureSchema.Table.BING_SEARCHES, {'table': ConfigureSchema.Table.BING_SEARCHES,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getBingSearchData(),
        'metrics': ['BING_SEARCHES'],
        'yextDimensions': ['ENTITY_IDS', 'WEEKS'],
        'tableauDimensions': ['entity_id', 'week']});
    metadata.set(
      ConfigureSchema.Table.SEARCH, {'table': ConfigureSchema.Table.SEARCH,
        'method': this.ajaxActions.getBatchedAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getSearchData(),
        'metrics': [
          ['ANSWERS_CLICK_THROUGH_RATE', 'ANSWERS_CLICKS', 'ANSWERS_SEARCHES',
            'ANSWERS_SEARCHES_WITH_CLICKS', 'ANSWERS_SESSIONS'],
          ['ANSWERS_SEARCHES_WITH_KG_RESULTS', 'ANSWERS_CASE_DEFLECTIONS',
            'ANSWERS_CASE_DEFLECTION_RATE', 'ANSWERS_CASE_STARTS', 'ANSWERS_CASE_SUBMITS'],
          ['ANSWERS_CLUSTERS', 'ANSWERS_KG_RESULT_RATE', 'ANSWERS_PERCENTAGE_OF_TOTAL_SEARCHES',
            'ANSWERS_SEARCH_TERMS'],
          ['ANSWERS_THUMBS_DOWN_EVENTS', 'ANSWERS_THUMBS_UP_EVENTS', 'ANSWERS_VOICE_SEARCHES']],
        'yextDimensions': ['ANSWERS_EXPERIENCE', 'DAYS'],
        'tableauDimensions': ['ANSWERS_EXPERIENCE', 'day']});
    metadata.set(
      ConfigureSchema.Table.FACEBOOK_LISTINGS, {'table': ConfigureSchema.Table.FACEBOOK_LISTINGS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getFacebookListingsData(),
        'metrics': ['FACEBOOK_IMPRESSIONS', 'FACEBOOK_CTA_CLICKS'],
        'yextDimensions': ['ENTITY_IDS', 'DAYS'],
        'tableauDimensions': ['entity_id', 'day']});
    metadata.set(
      ConfigureSchema.Table.GOOGLE_LISTINGS, {'table': ConfigureSchema.Table.GOOGLE_LISTINGS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getGoogleListingsData(),
        'metrics': ['GOOGLE_CUSTOMER_ACTIONS', 'GOOGLE_SEARCH_QUERIES'],
        'yextDimensions': ['ENTITY_IDS', 'DAYS'],
        'tableauDimensions': ['entity_id', 'day']});
    metadata.set(
      ConfigureSchema.Table.NEW_GOOGLE_LISTINGS, {'table': ConfigureSchema.Table.NEW_GOOGLE_LISTINGS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getNewGoogleListingsData(),
        'metrics': ['LISTINGS_IMPRESSIONS'],
        'yextDimensions': ['ENTITY_IDS', 'DAYS'],
        'tableauDimensions': ['entity_id', 'day']});
    metadata.set(
      ConfigureSchema.Table.GOOGLE_PHONE, {'table': ConfigureSchema.Table.GOOGLE_PHONE,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getGooglePhoneCallsData(),
        'metrics': ['GOOGLE_PHONE_CALLS'],
        'yextDimensions': ['GOOGLE_PHONE_CALL_HOURS', 'ENTITY_IDS'],
        'tableauDimensions': ['hour', 'entity_id']});
    metadata.set(
      ConfigureSchema.Table.LISTINGS, {'table': ConfigureSchema.Table.LISTINGS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getListingsData(),
        'metrics': ['SEARCHES', 'PROFILE_VIEWS', 'FEATURED_MESSAGE_CLICKS', 'LISTINGS_LIVE',
          'POWERLISTINGS_LIVE', 'LISTINGS_ACCURACY'],
        'yextDimensions': ['ENTITY_IDS', 'DAYS', 'PUBLISHERS'],
        'tableauDimensions': ['entity_id', 'day', 'publisher']});
    metadata.set(
      ConfigureSchema.Table.PAGES, {'table': ConfigureSchema.Table.PAGES,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getPagesData(),
        'metrics': ['STOREPAGES_CALLTOACTIONCLICKS', 'STOREPAGES_CLICKSTOWEBSITE',
          'STOREPAGES_DRIVINGDIRECTIONS', 'STOREPAGES_PAGEVIEWS', 'STOREPAGES_PHONECALLS',
          'STOREPAGES_SESSIONS'],
        'yextDimensions': ['ENTITY_IDS', 'DAYS'],
        'tableauDimensions': ['entity_id', 'day']});
    metadata.set(
      ConfigureSchema.Table.PROFILES, {'table': ConfigureSchema.Table.PROFILES,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getProfilesData(),
        'metrics': ['PROFILE_UPDATES'],
        'yextDimensions': ['ENTITY_IDS', 'FIELD_NAME', 'DAYS'],
        'tableauDimensions': ['entity_id', 'day', 'field_name']});
    metadata.set(
      ConfigureSchema.Table.REVIEWS_ANALYTICS, {'table': ConfigureSchema.Table.REVIEWS_ANALYTICS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getReviewsAnalyticsData(),
        'metrics': ['NEW_REVIEWS', 'AVERAGE_RATING', 'RESPONSE_COUNT', 'RESPONSE_RATE',
          'RESPONSE_TIME'],
        'yextDimensions': ['ENTITY_IDS', 'RATINGS', 'PARTNERS', 'DAYS'],
        'tableauDimensions': ['entity_id', 'ratings', 'partner', 'day']});
    metadata.set(
      ConfigureSchema.Table.SEARCHES, {'table': ConfigureSchema.Table.SEARCHES,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getSearchesData(),
        'metrics': ['ANSWERS_SEARCHES', 'ANSWERS_SEARCHES_WITH_KG_RESULTS', 'ANSWERS_SESSIONS'],
        'yextDimensions': ['DAYS', 'ANSWERS_SEARCH_TERM', 'ANSWERS_CONFIGURATION_VERSION_LABEL',
          'ANSWERS_TRAFFIC_TYPE', 'ANSWERS_HAS_KG_RESULTS', 'ANSWERS_HAS_DIRECT_ANSWER'],
        'tableauDimensions': ['day', 'ANSWERS_SEARCH_TERM', 'ANSWERS_CONFIGURATION_VERSION_LABEL',
          'ANSWERS_TRAFFIC_TYPE', 'ANSWERS_HAS_KG_RESULTS', 'ANSWERS_HAS_DIRECT_ANSWER']});
    metadata.set(
      ConfigureSchema.Table.SEARCHES_CLICKS, {'table': ConfigureSchema.Table.SEARCHES_CLICKS,
        'method': this.ajaxActions.getBatchedAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getSearchesClicksData(),
        'metrics': [
          ['ANSWERS_THUMBS_UP_EVENTS', 'ANSWERS_THUMBS_DOWN_EVENTS', 'ANSWERS_CLICKS'],
          ['ANSWERS_SEARCHES_WITH_CLICKS'],
          ['ANSWERS_SESSIONS'],
          ['ANSWERS_CLICK_THROUGH_RATE']],
        'yextDimensions': ['DAYS', 'ANSWERS_SEARCH_TERM', 'ANSWERS_CONFIGURATION_VERSION_LABEL',
          'ANSWERS_TRAFFIC_TYPE', 'ANSWERS_HAS_KG_RESULTS',
          'ENTITY_IDS', 'ANSWERS_HAS_DIRECT_ANSWER'],
        'tableauDimensions': ['entity_id', 'day', 'ANSWERS_SEARCH_TERM', 'ANSWERS_CONFIGURATION_VERSION_LABEL',
          'ANSWERS_TRAFFIC_TYPE', 'ANSWERS_HAS_KG_RESULTS', 'ANSWERS_HAS_DIRECT_ANSWER']});
    metadata.set(
      ConfigureSchema.Table.SEARCH_CASE_DEFLECTION, {'table': ConfigureSchema.Table.SEARCH_CASE_DEFLECTION,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getSearchCaseDeflectionData(),
        'metrics': ['ANSWERS_CASE_DEFLECTIONS', 'ANSWERS_CASE_DEFLECTION_RATE', 'ANSWERS_CASE_STARTS',
          'ANSWERS_CASE_SUBMITS', 'ANSWERS_SEARCHES', 'ANSWERS_SESSIONS'],
        'yextDimensions': ['DAYS', 'ANSWERS_SEARCH_TERM', 'ANSWERS_CONFIGURATION_VERSION_LABEL',
          'ANSWERS_TRAFFIC_TYPE', 'ANSWERS_HAS_KG_RESULTS',
          'ANSWERS_HAS_CASE_START', 'ANSWERS_HAS_CASE_SUBMIT'],
        'tableauDimensions': ['day', 'ANSWERS_SEARCH_TERM', 'ANSWERS_CONFIGURATION_VERSION_LABEL',
          'ANSWERS_TRAFFIC_TYPE', 'ANSWERS_HAS_KG_RESULTS', 'ANSWERS_HAS_CASE_START',
          'ANSWERS_HAS_CASE_SUBMIT']});
    metadata.set(
      ConfigureSchema.Table.GOOGLE_LISTING_ACTIONS, {'table': ConfigureSchema.Table.GOOGLE_LISTING_ACTIONS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getGoogleListingsActions(),
        'metrics': ['LISTINGS_ACTIONS'],
        'yextDimensions': ['ACTION'],
        'tableauDimensions': ['ACTION']});
    metadata.set(
      ConfigureSchema.Table.GOOGLE_SEARCH_KEYWORD_IMPRESSIONS, {'table': ConfigureSchema.Table.GOOGLE_SEARCH_KEYWORD_IMPRESSIONS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getGoogleSearchImpressions(),
        'metrics': ['LISTINGS_GOOGLE_SEARCH_TERM_IMPRESSIONS'],
        'yextDimensions': ['RAW_SEARCH_TERM'],
        'tableauDimensions': ['RAW_SEARCH_TERM']});
    metadata.set(
      ConfigureSchema.Table.TOTAL_LISTINGS_IMPRESSIONS, {'table': ConfigureSchema.Table.TOTAL_LISTINGS_IMPRESSIONS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getTotalListingsImpressions(),
        'metrics': ['TOTAL_LISTINGS_IMPRESSIONS'],
        'yextDimensions': ['ENTITY_IDS', 'WEEKS'],
        'tableauDimensions': ['entity_id', 'week']});
    metadata.set(
      ConfigureSchema.Table.GOOGLE_CALLS_ANALYTICS, {'table': ConfigureSchema.Table.GOOGLE_CALLS_ANALYTICS,
        'method': this.ajaxActions.getAnalyticsData,
        'route': yext.developerapps.routes.TableauConnector.getGoogleCallsAnalytics(),
        'metrics': ['GOOGLE_ANSWERED_CALLS', 'GOOGLE_MISSED_CALLS'],
        'yextDimensions': ['MONTHS'],
        'tableauDimensions': ['month']});
    return metadata;
  }
}

exports = DataRequestor;
